<ng-container *transloco="let t; prefix: 'financing.actions-section'">
  <div class="grid lg:grid-cols-2 gap-10 mb-10">
    <div
      class="bg-primary-700 flex flex-col justify-between rounded-small p-8 col-span-2 lg:col-span-1"
    >
      <div class="flex flex-col gap-4 mb-5">
        <h3 class="rfs:text-3xl text-white">
          {{ t("card01.title") }}
        </h3>
        <p class="text-primary-50">
          {{ t("card01.text") }}
        </p>
      </div>
      <div class="flex flex-wrap lg:flex-nowrap gap-5 justify-between">
        <div class="flex items-end">
          <button class="btn-primary" [localizedRouterLink]="['/loan-application']" >{{ t("card01.button") }}</button>
        </div>
        <div class="w-full flex justify-end lg:w-auto lg:block">
          <img
            class="lg:h-[100px] xl:h-auto"
            src="./assets/financing/unico-funding-interest.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div
      class="bg-[#FFE6DC] flex flex-col justify-between rounded-small p-8 col-span-2 lg:col-span-1"
    >
      <div class="flex flex-col gap-4 mb-5">
        <h3 class="rfs:text-3xl text-black">
          {{ t("card02.title") }}
        </h3>
        <p class="text-gray-950">
          {{ t("card02.text") }}
        </p>
      </div>
      <div class="flex flex-wrap lg:flex-nowrap gap-5 justify-between">
        <div class="flex flex-col justify-between gap-4">
          <img
            class="max-w-[122px]"
            src="./assets/financing/experts-avatars.png"
            alt=""
          />
          <button
            class="btn-secondary hover:bg-transparent hover:text-black hover:border-black"
            (click)="generalCallback()"
          >
            {{ t("card02.button") }}
          </button>
        </div>
        <div class="w-full flex justify-end lg:w-auto lg:block">
          <img
            class="lg:h-[130px] xl:h-auto"
            src="./assets/financing/call-experts.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
  <div class="bg-white rounded-small p-8 col-span-2">
    <div class="flex flex-col gap-10">
      <div class="flex flex-col lg:flex-row justify-between gap-3">
        <div class="lg:max-w-[72%] mb-8 lg:mb-0">
          <h3 class="rfs:text-2xl text-black mb-3">
            {{ t("card03.title") }}
          </h3>
          <p class="text-gray-700 mb-8">
            {{ t("card03.text") }}
          </p>
          <div class="max-w-[250px]">
            <button class="btn-secondary" [localizedRouterLink]="['/faq']">
              {{ t("card03.button") }}
            </button>
          </div>
        </div>
        <div class="flex justify-end">
          <img src="./assets/financing/loudspeaker.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</ng-container>
